<template>
  <v-card flat color="transparent">
    <v-card-text class="text-xs-center pb-0" v-if="product.material != null">
      <div class="subheading">{{product.material.fullName}}</div>
      <div>
        Produkt kód: {{product.material.productCode}} - Cena tabule:
        {{product.material.price}} €
      </div>
      <v-btn flat dark color="primary" @click="openDialog()">
        <v-icon dark>edit</v-icon>
      </v-btn>
    </v-card-text>
    <v-card-text v-else class="text-xs-center pb-0">
      <v-icon color="error" class="animated infinite bounce delay-2s">arrow_downward</v-icon>
      <div class="subheading">
        Vyberte materiál
        <!-- <v-badge color="red">
          <template v-slot:badge>1</template>
          <v-btn flat dark color="primary" @click="openDialog()">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-badge>-->
        <v-btn flat dark color="primary" @click="openDialog()">
          <v-icon dark>add</v-icon>
        </v-btn>
      </div>
    </v-card-text>

    <!-- ***************************************************************** DIALOG ****************************** -->

    <v-dialog v-model="dialog" width="850" :max-height="200">
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text">Materialy</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-list two-line dense>
                <v-subheader>Obľubené materiály</v-subheader>
                <v-divider class="mt-3"></v-divider>
                <template v-for="(item, index) in recommendedHp">
                  <v-list-tile :key="index" avatar @click="selectHp(item)">
                    <v-list-tile-avatar>
                      <v-img :src="images.demosImageUrl(item)" aspect-ratio="2"></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{item.fullName}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        Produkt kód: {{item.productCode}} - Cena tabule:
                        {{item.price}} €
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
            <v-flex xs12 md6 pa-2>
              <v-list two-line dense>
                <v-text-field
                  :items="allHp"
                  :loading="isLoading"
                  v-model="search"
                  label="Iný materiál"
                  no-data-text
                  no-filter
                  hide-no-data
                  hide-details
                  placeholder="Vyhľadajte svoj materiál"
                  return-object
                ></v-text-field>
                <template v-for="(item, index) in allHp">
                  <v-list-tile :key="index" avatar @click="selectHp(item)">
                    <v-list-tile-avatar>
                      <v-img :src="images.demosImageUrl(item)" aspect-ratio="2"></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{item.fullName}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        Produkt kód: {{item.productCode}} - Cena tabule:
                        {{item.price}} €
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Zatvoriť</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import images from "@/views/cutting/js/images";
import Controller from "@/mixins/controlsMixins";
import CuttingService from "@/services/CuttingService";

export default {
  name: "CuttingEdge",
  mixins: [Controller],
  props: ["product"],
  components: {},
  data() {
    return {
      dialog: false,
      recommendedHp: [],
      allHp: [],
      isLoading: false,
      search: null,
      doneTypingInterval: 1000,
      typingTimer: null,
      images: images
    };
  },
  methods: {
    openDialog() {
      this.findRecommendedHp();
    },
    findRecommendedHp() {
      this.openGlobalLoader("Načítava sa ...");
      new CuttingService()
        .getDecorsSearch("dub")
        .then(response => {
          console.log(response.data);
          this.recommendedHp = response.data;
          this.dialog = true;
        })
        .catch(() => {
          this.recommendedHp = [];
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    selectHp(item) {
      this.product.decorId = item.productCode;
      this.product.material = item;
      this.dialog = false;
      this.$emit("selectedMaterial");
    },
    removeEdge() {
      this.product.edge[this.property] = null;
    },
    findDecor(val) {
      if (this.isLoading || val === "" || val === null) {
        return;
      }

      console.log(val);

      this.isLoading = true;

      new CuttingService()
        .getDecorsSearch(val)
        .then(r => {
          console.log(r.data);
          this.allHp = r.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  watch: {
    search(val) {
      if (val == null) {
        return;
      }

      window.clearTimeout(this.typingTimer);

      this.typingTimer = setTimeout(
        () => this.findDecor(val),
        this.doneTypingInterval
      );
    }
  }
};
</script>

<style>
</style>